"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MapZone {
    constructor(zoneOptions) {
        this.geoData = zoneOptions.geoData || '';
        this.fillColor = zoneOptions.fillColor || '#eebb5450';
        this.strokeColor = zoneOptions.strokeColor || '#eebb54';
        this.strokeWidth = zoneOptions.strokeWidth || 3;
        this.zoneName = zoneOptions.zoneName || 'Default Zone';
        this.enableHoverInteraction = zoneOptions.enableHoverInteraction || false;
        this.enableSelectInteraction = zoneOptions.enableSelectInteraction || false;
        this.centerZone = zoneOptions.centerZone || false;
        this.avg = zoneOptions.avg || 0;
        this.markers = zoneOptions.markers || [];
        this.preciseResult = zoneOptions.preciseResult || false;
        this.modifyInteraction = zoneOptions.modifyInteraction || false;
        this.crop = zoneOptions.crop || '';
    }
}
exports.default = MapZone;
